import { all } from 'redux-saga/effects'
import { sagaAuthenticationToken } from './sagaAuthenticationToken';
import { sagaBookingTypes } from './sagaBookingTypes';
import { sagaExtraItems } from './sagaExtraItems';
import { sagaMember } from './sagaMember'
import { sagaPaymentTransaction } from './sagaPaymentTransaction'
import { sagaIP } from './sagaIP';
import { sagaDisplayAreas } from './sagaDisplayAreas';
import { sagaShopCart } from './sagaShopCart';
import { sagaGiftCardHold } from './sagaGiftCardHold';
import { sagaCoupon } from './sagaCoupon';
import { sagaUniqueCouponHolds } from './sagaUniqueCouponHolds';
import { sagaMemberValidation } from './sagaMemberValidation';
import { sagaDonation } from './sagaDonation';
import { sagaTransactionFee } from './sagaTransactionFee';
import { sagaMembershipPackages } from './sagaMembershipPackages';
import { sagaGaTicket } from './sagaGaTicket';
import { sagaLostMember } from './sagaLostMember';
import { sagaMemberMemberships } from './sagaMemberMemberships';
import { sagaCustomer } from './sagaCustomer';
import { bookingSaga } from './sagaBooking';
import { sagaGiftcarddisplayAreas } from './sagaGiftcarddisplayAreas';
import { sagaGiftcards } from './sagaGiftcards';
import { sagaCostRate } from './sagaCostRate';
import { sagaIdMeUserData } from './sagaIdMeUserData';
import { sagaBookingUserDefinedFields } from './sagaBookingUserDefinedFields';
import { sagaOrderLocations } from './sagaOrderLocations';
import { sagaOrderMenu } from './sagaOrderMenu';
import { sagaMembershipUserDefinedFields } from './sagaMembershipUserDefinedFields';
import { sagaCustomerUDFs } from './sagaCustomerUDFs';
import { sagaCountryAndState } from './sagaCountryAndState';
import { sagaOrganizationSection } from './sagaOrganizationSection';
import { sagaProduct } from './sagaProduct';

export function* rootSaga() {
  yield all([
    ...sagaAuthenticationToken,
    ...sagaBookingTypes,
    ...sagaMember,
    ...sagaPaymentTransaction,
    ...sagaExtraItems,
    ...sagaIP,
    ...sagaDisplayAreas,
    ...sagaShopCart,
    ...sagaGiftCardHold,
    ...sagaCoupon,
    ...sagaUniqueCouponHolds,
    ...sagaMemberValidation,
    ...sagaDonation,
    ...sagaTransactionFee,
    ...sagaMembershipPackages,
    ...sagaGaTicket,
    ...sagaLostMember,
    ...sagaMemberMemberships,
    ...sagaCustomer,
    ...bookingSaga,
    ...sagaGiftcarddisplayAreas,
    ...sagaGiftcards,
    ...sagaCostRate,
    ...sagaIdMeUserData,
    ...sagaBookingUserDefinedFields,
    ...sagaOrderLocations,
    ...sagaOrderMenu,
    ...sagaMembershipUserDefinedFields,
    ...sagaCustomerUDFs,
    ...sagaCountryAndState,
    ...sagaProduct,
     ...sagaOrganizationSection
  ]);
}

//export default rootSaga;
